import { FactoryProvider, InjectionToken, Provider } from '@angular/core';
import { Observable } from 'rxjs';

export const MENU_ITEM_REFRESHER_TOKEN = new InjectionToken<Observable<void>[]>('MenuItemRefresher');

export function provideMenuItemRefresher(refresher: Observable<void> | RefresherFactoryDefinition): Provider {
    if (refresher instanceof Observable) {
        return {
            provide: MENU_ITEM_REFRESHER_TOKEN,
            useValue: refresher,
            multi: true
        };
    }
    return {
        provide: MENU_ITEM_REFRESHER_TOKEN,
        ...refresher,
        multi: true
    };
}

interface RefresherFactoryDefinition extends Omit<FactoryProvider, 'provide' | 'multi'> {
    useFactory: (...deps: any[]) => Observable<void>;
}
